import React from 'react';
import { Typography, Container, Divider } from '@mui/material';

const PrivacyPolicy: React.FC = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        marginTop: 4,
        marginBottom: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* Page Header */}
      <Typography
        variant="h2"
        gutterBottom
        sx={{
          fontFamily: 'Montserrat',
          textAlign: 'center',
          color: 'dodgerblue',
        }}
      >
        Privacy Policy
      </Typography>
      <Divider
        sx={{
          width: '100%',                // ← full width
          borderColor: 'dodgerblue',
          borderWidth: '1px',           // thickness
          mb: 2,                        // space below
        }}
      />

        {/* Section 1 */}
        <Typography variant="h5" gutterBottom>
          <strong>Introduction</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          At American Polling Machine, LLC, we are committed to protecting the privacy and security of our users. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our website, mobile applications, and services (collectively, the "Services").
        </Typography>

        {/* Section 2 */}
        <Typography variant="h5" gutterBottom>
          <strong>Information We Collect</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          We may collect personal information that you voluntarily provide to us when you register for our service. The types of personal information we may collect include your email address, phone number, and zip code.
        </Typography>

        {/* Section 3 */}
        <Typography variant="h5" gutterBottom>
          <strong>Use of Information</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          We use the information we collect to provide, maintain, and improve our Services, to communicate with you, and to personalize your experience. We may also use your information to send you updates, promotional materials, and other information that may be of interest to you.
        </Typography>

        {/* Section 4 */}
        <Typography variant="h5" gutterBottom>
          <strong>Information Sharing</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          We do not share, sell, rent, or disclose your personal information to any third parties. Your information is kept strictly confidential and is only used in accordance with this Privacy Policy.
        </Typography>

        {/* Section 5 */}
        <Typography variant="h5" gutterBottom>
          <strong>Data Security</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          We take the security of your personal information seriously. We implement appropriate technical and organizational measures to protect your data from unauthorized access, disclosure, alteration, or destruction. However, please note that no method of transmission over the Internet or method of electronic storage is completely secure.
        </Typography>

        {/* Section 6 */}
        <Typography variant="h5" gutterBottom>
          <strong>Your Rights</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          You have the right to access, correct, update, or delete your personal information at any time. If you wish to exercise any of these rights, please contact us at support@letspoll.com.
        </Typography>

        {/* Section 7 */}
        <Typography variant="h5" gutterBottom>
          <strong>Changes to This Privacy Policy</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          We may update this Privacy Policy from time to time to reflect changes in our practices or legal obligations. We will notify you of any significant changes by posting the new Privacy Policy on our website and updating the "Effective Date" at the top of this page. We encourage you to review this Privacy Policy periodically to stay informed about how we are protecting your information.
        </Typography>

        {/* Section 8 */}
        <Typography variant="h5" gutterBottom>
          <strong>Contact Us</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:
        </Typography>
        <Typography variant="body1">
          American Polling Machine, LLC
          <br />
          support@letspoll.com
        </Typography>
    </Container>
  );
};

export default PrivacyPolicy;
